import { Routes } from '@angular/router';
import { PaneladminComponent } from './paneladmin.component';
import {guardsGuard } from './guards.guard';
import { LoginadmComponent } from '../../loginadm/loginadm.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { adminInterceptor } from '../admin-interceptor.interceptor';
import { ClientesComponent } from './clientes/clientes.component';
import { LicencasComponent } from './licencas/licencas.component';
import { WebhooksComponent } from './webhooks/webhooks.component';
import { ConfiguracoesComponent } from './configuracoes/configuracoes.component';
import { RevendedoresComponent } from './revendedores/revendedores.component';


export const adminRoutes: Routes = [
    {
        path: '',
        component: LoginadmComponent,
    },

    {
        path: 'panel',
        component: PaneladminComponent,
        providers: [
            provideHttpClient(withInterceptors([adminInterceptor]))
        ],
        canActivate: [guardsGuard],
        canActivateChild: [guardsGuard],
        children: [
            {
                path: '',
                redirectTo: 'clientes',
                pathMatch: 'full'
            },
            {
                path: 'clientes',
                component: ClientesComponent,
            },
            {
                path: 'licencas',
                component: LicencasComponent,
            },
            {
                path: 'webhooks',
                component: WebhooksComponent,
            },
            {
                path: 'configuracoes',
                component: ConfiguracoesComponent,
            },
            {
                path: 'revendedores',
                component: RevendedoresComponent,
            }
        ]
    }
]
